// Act form fields whose value is rendered into the confirmed PDF but is never
// stored. Mirrors MAINTENANCE_ACT_TRANSIENT_FIELDS in the API's php/constants.php:
// the server blanks these on every write and on every read, and re-injects the
// posted value into the render only when confirming. So there is no reason to
// upload the customer's signature — a base64 PNG data URL — when saving.
//
// Matched by NAME, not by input type: technician_signature and
// documentation_tech_signature are the same 'signature' type but are auto-filled
// from the technician's profile and ARE stored, so a type-based match would
// silently stop persisting them.
//
// Adding a customer-signature field to a template means adding its name to both
// this list and the PHP constant.
export const ACT_TRANSIENT_FIELDS = [
    'client_signature',
    'documentation_contact_signature',
];

/**
 * Blank every transient field in collected act form data, in place.
 *
 * The collected shape is a mix of row arrays and flat objects depending on the
 * section, so this walks the whole structure by key name — the same approach
 * blank_transient_fields() takes on the server, including blanking to '' rather
 * than deleting the key, so the payload shape is unchanged.
 *
 * @param {*} value Collected form data, or any nested part of it.
 */
export function blankTransientFields(value) {
    if (Array.isArray(value)) {
        value.forEach(blankTransientFields);
        return;
    }
    if (value && typeof value === 'object') {
        Object.keys(value).forEach(key => {
            if (ACT_TRANSIENT_FIELDS.includes(key)) {
                value[key] = '';
            } else {
                blankTransientFields(value[key]);
            }
        });
    }
}
